import {
    ACTIVATE_USER_ERROR,
    ACTIVATE_USER_START,
    ACTIVATE_USER_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.activate, action = {type: ''}) => {
    switch (action.type) {
        case ACTIVATE_USER_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case ACTIVATE_USER_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case ACTIVATE_USER_ERROR:
            return {
                error: true,
                loading: false,
                success: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/activateUserReducer.js